import React from "react";
import { courseRatingsApi } from "api/courseRatingsApi";
import { useQuery } from "@tanstack/react-query";
import { Stars } from "components/atoms";
import { TanTableClient, TanTableColumn } from "components/molecules";
import { formatDate } from "utils";
import { routes } from "consts";
import { CourseRatingApi } from "api/types";
import { QUERIES_KEYS } from "queries";

interface CourseRatingsProps {
  courseId: number;
}
export const CourseRatings = ({ courseId }: CourseRatingsProps) => {
  const { isLoading, data } = useQuery({
    queryKey: QUERIES_KEYS.COURSE_RATINGS(courseId),
    queryFn: () => courseRatingsApi.getByCourseId(courseId),
  });

  const columns = React.useMemo<TanTableColumn<CourseRatingApi>[]>(() => cols, []);
  if (!data?.data) return null;

  const tableData = data.data.ratings.map((x) => ({ ...x, name: x.firstName + " " + x.surname }));

  return (
    <>
      <div>
        <span className="flex items-center justify-center gap-1 text-sm">
          Średnia z {data.data.ratings.length} ocen:
          <Stars numberOfStars={data.data.average} /> ({Math.round(data.data.average * 10) / 10})
        </span>
      </div>
      <TanTableClient data={tableData} columns={columns} hideBorder />
    </>
  );
};
const cols: TanTableColumn<CourseRatingApi>[] = [
  {
    id: "name",
    accessorKey: "name",
    header: "Imię i nazwisko",
    enableColumnFilter: false,
    cell: (info) => (
      <a target="_blank" href={routes.STUDENT(info.row.original.id)} className="hover:underline">
        {info.getValue<string>()}
      </a>
    ),
  },
  {
    id: "rating",
    accessorKey: "rating",
    header: "Ocena",
    size: 20,
    enableColumnFilter: false,
    cell: (info) => {
      return (
        <div>
          <Stars numberOfStars={info.getValue<number>()} />
        </div>
      );
    },
  },

  {
    id: "createdDate",
    accessorKey: "createdDate",
    header: "Data",
    size: 20,
    cell: (info) => <span className="truncate">{formatDate(info.getValue<Date>(), true)}</span>,
  },
];
